import React from "react";
import Header from "./Header";
import InputTodo from "./InputTodo";
import TodoList from "./TodosList";
import { v4 as uuidv4 } from "uuid";
import { Route, Routes } from "react-router-dom";
import About from "./About";
import NotMatch from "./NotMatch";
import Navbar from "./Navbar";
class TodoContainer extends React.Component {
  state = {
    todos: [],
  };
  handleChange = (id) => {
    this.setState((prevState) => {
      return {
        todos: prevState.todos.map((todo) => {
          if (todo.id === id) {
            return { ...todo, completed: !todo.completed };
          }
          return todo;
        }),
      };
    });
  };
  delTodo = (id) => {
    this.setState({
      todos: [
        ...this.state.todos.filter((todo) => {
          return todo.id !== id;
        }),
      ],
    });
  };
  addTodoItem = (title) => {
    const newTodo = {
      id: uuidv4(),
      title: title,
      completed: false,
    };
    this.setState({
      todos: [...this.state.todos, newTodo],
    });
  };
  setUpdate = (updatedTitle, id) => {
    this.setState({
      todos: this.state.todos.map((todo) => {
        if (todo.id === id) {
          todo.title = updatedTitle;
        }
        return todo;
      }),
    });
  };
  // componentDidMount() {
  //   fetch("https://jsonplaceholder.typicode.com/todos")
  //     .then(response => response.json())
  //     .then(data => this.setState({ todos: data }));
  // }

  componentDidMount() {
    const temp = localStorage.getItem("todos");
    const loadedTodos = JSON.parse(temp);
    if (loadedTodos) {
      this.setState({
        todos: loadedTodos,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.todos !== this.state.todos) {
      const temp = JSON.stringify(this.state.todos);
      localStorage.setItem("todos", temp);
    }
  }

  render() {
    return (
      <React.Fragment>
        <Navbar />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <div className="container">
                <div className="inner">
                  <Header />
                  <InputTodo addTodoProps={this.addTodoItem} />
                  <TodoList
                    todos={this.state.todos}
                    handleChangeProps={this.handleChange}
                    deleteTodoProps={this.delTodo}
                    setUpdate={this.setUpdate}
                  />
                </div>
              </div>
            }
          ></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="*" element={<NotMatch />}></Route>
        </Routes>
      </React.Fragment>
    );
  }
}
export default TodoContainer;
